/**
 * Handles scrolling effect
 * @module stickyScroll
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'stickyScroll';
export const SCROLL_EVENT = 'scroll';
export const RESIZE_EVENT = 'resize';
export const WINDOW = window;

export const DEFAULTS = {
  marginTop: 0,
};

const getMaxHeight = () => {

}

/**
 * Handle Scroll Event
 * @param  {jQuery} $el - scroll Element
 */
const scrollEventHandler = (el, container, opts) => {
  const { marginTop } = opts;

  $(WINDOW).on(`${SCROLL_EVENT} ${RESIZE_EVENT}`, () => {
    const windowHeight = $(window).height();
    const scroll = $(window).scrollTop();
    const headerHeight = $('.site-header__content').outerHeight();

    const containerBoundaries = container.offset();
    const containerHeight = container.outerHeight();
    const containerTopPosition = containerBoundaries.top;

    // get navMaxHeight
    const navFooterOffset = scroll + windowHeight - containerTopPosition - containerHeight;
    const navFooterOffsetValue = navFooterOffset < 0 ? 0 : navFooterOffset;
    const navMaxHeight = windowHeight - headerHeight - navFooterOffsetValue;


    el.css({ maxHeight: navMaxHeight });

    if (scroll + headerHeight + marginTop > containerBoundaries.top) {
      el.addClass("sticky-scroll--is-fixed").css({ top: headerHeight + marginTop });
    } else {
      // Scrollling above
      el.removeClass("sticky-scroll--is-fixed");
    }
  });
};

/**
 * Set Event setEventListeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = (el, container, opts = {}) => {
  scrollEventHandler(el, container, opts);
};

// const getBoundaries = (el) => { el.offset() }

/**
 * Initializes Fixed Scroll.
 * @param {HTMLElement} el - scroll Element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function stickyScroll(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const container = $el.parent('[data-sticky-scroll-container]');
  applyEventHandlers($el, container, opts);
}
// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, stickyScroll);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/sticky-scroll.js